export const trackingListener = {
  initial: 'idle',
  states: {
    idle: {
      on: {
        TRACK_PAGE_CHANGE: 'transient',
        ENVIROMENT_USER_ACTION_TRIGGERED: {
          cond: 'delayedTrackingNotInstalled',
          actions: [
            {
              type: 'sendTrackEvents',
            },
          ],
        },
      },
    },
    transient: {
      always: [
        {
          target: 'waitingForSession',
          cond: 'isSessionNotResolved',
        },
        { target: 'tracking' },
      ],
    },
    waitingForSession: {
      on: {
        SESSION_STATE_LOGGED_OUT: 'tracking',
        SESSION_STATE_LOGGED_IN: 'tracking',
      },
    },
    tracking: {
      entry: 'trackPageChange',
      always: 'idle',
    },
  },
};
